import { createFileRoute } from '@tanstack/react-router';
import { ConfigurationRiskCategories } from './RiskCategories';

export const Route = createFileRoute('/console/$orgId/configuration/risk/categories')({
    staticData: { metadata: { title: 'Risk categories' } },
    component: () => <ConfigurationRiskCategories />,
});
